module.exports = __webpack_public_path__ + "img/ceramic.4f53ad4.webp";